// slides-library/shared/utils/slide-selection.ts
//
// WHAT A SELECTION OF SLIDES IS, once the user acts on it.
//
// The library keeps the picked slides in a Map, which remembers the order they
// were picked in. That order is the deck's order: the card shows it as a
// number, and "Use slides" and "Create with AI" both build the new document
// from the slides in exactly that sequence.

import { DEFAULT_STORY } from "@/shared/constants";
import type { SelectedSlide } from "../store/types";

/** The 1-based position of `id` in the selection, or null when not picked. */
export const selectionOrderOf = (
  selection: Map<string, SelectedSlide>,
  id: string,
): number | null => {
  const index = Array.from(selection.keys()).indexOf(id);
  return index === -1 ? null : index + 1;
};

/**
 * The picked slides as a story, in the order they were picked: the base
 * document with these slides in place of its blank one. What "Use slides"
 * has always created, and what "Create with AI" now writes into.
 */
export const slidesTemplateStory = (
  selected: Iterable<SelectedSlide>,
  base: Record<string, unknown> = structuredClone(
    DEFAULT_STORY,
  ) as unknown as Record<string, unknown>,
): Record<string, unknown> => ({
  ...base,
  slides: Array.from(selected, (item) => item.slide),
});
